import { atom } from "recoil";
import { recoilPersist } from "recoil-persist";

const { persistAtom } = recoilPersist();

export const userStateAtom = atom<any>({
  key: "userStateAtom",
  default: {
    isLoggedIn: false,
    userData: null,
  },
  effects_UNSTABLE: [persistAtom],
});
